import React, { useState } from "react";
import { documentTitle, formatDocumentDate } from "../model/complianceRules";
import { rowStyles as styles } from "./complianceStyles";

function RenameForm({ draftName, busy, onChange, onSubmit, onCancel }) {
    const hasName = Boolean(draftName.trim());
    return (
        <div style={styles.renameForm}>
            <input
                value={draftName}
                onChange={event => onChange(event.target.value)}
                onKeyDown={event => {
                    if (event.key === "Enter") onSubmit();
                    if (event.key === "Escape") onCancel();
                }}
                autoFocus
                style={styles.renameInput}
            />
            <button
                type="button"
                disabled={busy || !hasName}
                onClick={onSubmit}
                style={styles.confirm(hasName, busy || !hasName)}
            >
                OK
            </button>
            <button type="button" disabled={busy} onClick={onCancel} style={styles.secondary(busy, styles.gris)}>
                Annuler
            </button>
        </div>
    );
}

export default function DocumentRow({ document, busy, onOpen, onDelete, onRename }) {
    const [editing, setEditing] = useState(false);
    const [draftName, setDraftName] = useState(document.fileName || "");
    const submitRename = () => {
        const trimmed = draftName.trim();
        if (!trimmed) return;
        onRename(document, trimmed);
        setEditing(false);
    };
    const resetDraft = value => {
        setDraftName(document.fileName || "");
        setEditing(value);
    };

    return (
        <div style={styles.row}>
            {editing ? (
                <RenameForm
                    draftName={draftName}
                    busy={busy}
                    onChange={setDraftName}
                    onSubmit={submitRename}
                    onCancel={() => resetDraft(false)}
                />
            ) : (
                <button type="button" onClick={() => onOpen(document)} style={styles.open}>
                    {documentTitle(document)}
                    <span style={styles.meta}>
                        {formatDocumentDate(document.uploadedAt)}
                        {document.uploadedBy ? ` · ${document.uploadedBy}` : ""}
                    </span>
                </button>
            )}
            <div style={styles.actions}>
                {!editing && (
                    <button type="button" disabled={busy} onClick={() => resetDraft(true)} style={styles.secondary(busy, styles.petrole)}>
                        Renommer
                    </button>
                )}
                <button type="button" disabled={busy} onClick={() => onDelete(document)} style={styles.secondary(busy, styles.gris)}>
                    Supprimer
                </button>
            </div>
        </div>
    );
}
